import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"

export type TierType = 'initiate' | 'creator' | 'architect'

interface TierBadgeProps {
  tier: TierType
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const tierConfig = {
  initiate: {
    label: 'Initiate',
    className: 'tier-badge-initiate',
    icon: '◦'
  },
  creator: {
    label: 'Creator',
    className: 'tier-badge-creator',
    icon: '◈'
  },
  architect: {
    label: 'Architect', 
    className: 'tier-badge-architect',
    icon: '◆'
  }
}

export function TierBadge({ tier, className, size = 'md' }: TierBadgeProps) {
  const config = tierConfig[tier]
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  }
  
  return (
    <Badge 
      className={cn(
        'font-medium tracking-wide transition-all duration-200',
        config.className,
        sizeClasses[size],
        className
      )}
    >
      <span className="mr-1.5">{config.icon}</span>
      {config.label}
    </Badge>
  )
}